import HundredBricksAPIError from '../../HundredBricksAPIError';
class ValidateFiscalDataError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ValidateFiscalDataError', ...args);
    }
}
export default ValidateFiscalDataError;
